import { ErrorBoundary } from "react-error-boundary";
import { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import routes from "router/router.config";
import { Loader, ErrorFallback } from "./components";

export function App() {
  const element = useRoutes(routes);
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Suspense fallback={<Loader />}>{element}</Suspense>
    </ErrorBoundary>
  );
}

export default App;
